/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wise_Stout_Kangaroo_PopInputs */

const en_wise_stout_kangaroo_pop = /** @type {(inputs: Wise_Stout_Kangaroo_PopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log out`)
};

const de_wise_stout_kangaroo_pop = /** @type {(inputs: Wise_Stout_Kangaroo_PopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abmelden`)
};

/**
* | output |
* | --- |
* | "Log out" |
*
* @param {Wise_Stout_Kangaroo_PopInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wise_stout_kangaroo_pop = /** @type {((inputs?: Wise_Stout_Kangaroo_PopInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wise_Stout_Kangaroo_PopInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wise_stout_kangaroo_pop(inputs)
	return de_wise_stout_kangaroo_pop(inputs)
});